export default "__VITE_ASSET__1XgU9to4__"